import { APIProcessName } from "@common/constants/process-names";

const ACCRUAL_APPROVE_SOURCE_TYPES: ReadonlySet<string> = new Set([
    APIProcessName.ACCRUAL_REVIEW_APPROVE,
    APIProcessName.ACCRUAL_REVIEW_BULK_APPROVE,
]);

const ACCRUAL_MATCH_SOURCE_TYPES: ReadonlySet<string> = new Set([
    APIProcessName.ACCRUAL_MATCH_CREATE,
    APIProcessName.ACCRUAL_MATCH_REMOVE,
]);

export function isAccrualApproveSourceType(
    sourceType: string | undefined | null,
): boolean {
    return sourceType != null && ACCRUAL_APPROVE_SOURCE_TYPES.has(sourceType);
}

export function isAccrualMatchSourceType(
    sourceType: string | undefined | null,
): boolean {
    return sourceType != null && ACCRUAL_MATCH_SOURCE_TYPES.has(sourceType);
}

export function isAccrualEffectiveCountSource(
    sourceType: string | undefined | null,
): boolean {
    return (
        isAccrualApproveSourceType(sourceType) ||
        isAccrualMatchSourceType(sourceType)
    );
}
